<template>
  <b-modal
    :id="modalId"
    ref="deleterequirementmodal"
    :title="requirements.length > 1 ? `Are you sure you want to delete ${requirements.length} requirements?` : 'Are you sure you want to delete this requirement?'"
    name="delete-requirement-modal"
    size="lg"
    :busy="loading"
    ok-title="Delete"
    close-title="Cancel"
    hide-header-close
    @ok="handleOk">
    This action can not be undone
    <div slot="modal-ok" v-if="loading">
      <icon name="spinner" pulse></icon> Deleting
    </div>
  </b-modal>
</template>

<script>
  import utilsMixin from '@/mixins/utils'
  export default {
    data () {
      return {
        loading: false
      }
    },
    props: {
      modalId: String,
      requirements: Array
    },
    mixins: [utilsMixin],
    methods: {
      handleOk (e) {
        e.preventDefault()
        this.loading = true
        this.submitData()
      },
      submitData () {
        this.$ga.event('requirement', 'delete', this.requirements.length > 1 ? 'bulk' : 'single', 1)
        this.$http.post(
          '/api/requirement/delete/bulk',
          {
            requirements: this.requirements
          }
        ).then(response => {
          window.AP.flag.create({
            title: 'Success!',
            body: this.requirements.length > 1 ? 'Requirements deleted successfully' : 'Requirement deleted successfully',
            type: 'success',
            close: 'auto'
          })
          this.loading = false
          this.setTheState()
          this.$refs.deleterequirementmodal.hide()
        }, error => {
          let errorString = this.createErrorStringFromResponse(error.response.data)
          let requirementWord = this.requirements.length > 1 ? 'requirements' : 'requirement'
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem deleting your ${requirementWord}: ${errorString}`,
            type: 'error'
          })
          this.loading = false
        })
      },
      setTheState () {
        this.$store.commit('setNeedToRefreshItemsList', true)
        this.$store.commit('setCurrentItem', null)
        this.$store.commit('clearSelectedRequirements')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DeleteRequirementModal.vue?35bc0888